import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { FormattedMessage } from 'react-intl';
import IconButton from '@mui/material/IconButton';
import { useDisclosure } from '../../../hooks/useDisclosure';
import { useAuth } from '../../../contexts/authContext';
import { useRef } from 'react';
import UserProfileDialog from '../../../features/userProfile/UserProfile';


export default function AccountPopover() {
  const auth = useAuth();
  const anchorRef = useRef(null);
  const disclosure = useDisclosure();
  const userProfileDialogDisclosure = useDisclosure();

  const handleOpenProfile = () => {
    disclosure.close();
    userProfileDialogDisclosure.open();
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={disclosure.toggle}
        color="inherit"
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={disclosure.isOpen}
        onClose={disclosure.close}
      >

        <MenuItem onClick={handleOpenProfile}>
          <FormattedMessage id='navbar.accountPopover.button.profile' defaultMessage='Profile' />
        </MenuItem>

        <MenuItem onClick={auth.signOut}>
          <FormattedMessage id='navbar.accountPopover.button.signout' defaultMessage='Sign out' />
        </MenuItem>
      </Menu>
      {userProfileDialogDisclosure.isOpen && <UserProfileDialog onClose={userProfileDialogDisclosure.close} />}
    </>
  );
}